import { Button, Icon, Text } from 'components'
import styles from './styles.module.scss'

type NoteProps = {
  message: string
  onAction?: () => void
}

const Note = ({ message, onAction }: NoteProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Icon name="warning" width={18} color="accent-red-default" />
        <Text size="sm" as="p" color="accent-red-bold">
          {message}
        </Text>
      </div>

      <Button color="red" appearance="tertiary" onClick={onAction}>
        Cadastrar
      </Button>
    </div>
  )
}

export default Note
